export default __webpack_public_path__ + "static/bw-2015-jose-1856566516a21db0f3f64bd23d094acc.jpg";